import Page from "../components/Page"

const is_page = {
    components: {
        Page
    },
    mounted () {
        if(window.location.hash) this.scroll_to_hash(window.location.hash)
    },
    methods: {
        statused (status) {
            this.page_status = status
            this.waiting = false
        },
        page_autoscroll () {
            if(!!this.$route.meta && !!this.$route.meta.scroll_position && (this.$route.meta.scroll_position !== true)) {
                setTimeout(() => {
                    window.scrollTo({ top: this.$route.meta.scroll_position.y, left: this.$route.meta.scroll_position.x })
                }, 250)
            }
        },
        scrolled (event, element) {
            const set_current_section = section_id => {
                if(this.current_section !== section_id) {
                    this.current_section = section_id
                    history.pushState(null, document.title, `${document.location.pathname}#${section_id}`)
                }
            }
            const window_height = (window.innerHeight || document.documentElement.clientHeight) * 0.33
            const total_height = element.getBoundingClientRect().height

            const sections = Array.from(element.getElementsByClassName("toc-section-anchor"))

            if(!!sections.length && (window.scrollY <= 0)) set_current_section(sections[0].id)
            else if(!!sections.length && (window.scrollY >= total_height)) set_current_section(sections[sections.length - 1].id)
            else {
                let current_element = null
                sections.forEach(
                    (element) => {
                        const rect = element.getBoundingClientRect()
                        if(rect.bottom <= window_height) current_element = element
                    }
                )
                if(current_element) set_current_section(current_element.id)
            }
        },
        scrollto (event) {
            this.scroll_to_hash(event.target.hash)
        },
        scroll_to_hash (hash) {
            const target = document.getElementById(hash.replace(/#/, ""))
            if(target) {
                const header = document.querySelectorAll("header.navbar")
                window.scrollTo({ top: target.getBoundingClientRect().y + window.scrollY - ((header && header.length) ? (header[0].offsetHeight * 1.25) : 0), left: 0, behavior: "smooth" })
            }
        }
    },
    data () {
        return {
            page_status: 200,
            waiting: true,
            page_id: "",
            current_section: ""
        }
    }
}

export default is_page
